import React from 'react';
import { IconPropType } from '../../../../Interfaces/IconPropType';
export const Byggefelt = (props: IconPropType) => {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height * (16 / 15) : 16}
      height={height ? height : width ? width * (15 / 16) : 15}
      viewBox="0 0 16 15"
      version="1.1"
    >
      <path
        d="M13.5 6v.53c0 .68-.37 1.3-.94 1.57A1 1 0 0012 9c0 .53.47 1 1 1a1 1 0 001-1 .5.5 0 011 0 2 2 0 01-2 2c-1.08 0-2-.92-2-2 0-.77.43-1.46 1.12-1.8.23-.11.38-.37.38-.67V6H6v8.5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V6H.5a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5H2V.5c0-.28.22-.5.5-.5h1.55c.15 0 .3.07.39.2L5.85 2h7.2c.16 0 .3.07.4.18l2.44 3a.5.5 0 01-.39.82h-2zM11 5V3h1v2h2l-1.57-2H6v2h2V3h1v2h2zM5 8V6H3v8h2v-2H3v-1h2V9H3V8h2zm0-3V3H3v2h2zm-.42-3L3.8 1H3v1h1.58zM2 5V3H1v2h1z"
        fill="#425971"
        fillRule="nonzero"
      />
    </svg>
  );
};

export default Byggefelt;
